module.exports = __webpack_public_path__ + "static/fluent-modal-244169155f957ea32ec7a7bd75f4594d.png";